import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OptionsService {
  private _http = inject(HttpClient);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  public options(path: string): Observable<any> {
    return this._http.options(path, {}).pipe(
      switchMap(() => of(true)),
      catchError((err) => {
        if (err.status !== 403) return throwError(err);
        return of(false);
      }),
    );
  }
}
